import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedConfigurations = (): string[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.getAll('configuration'), [searchParameters]);
};

export default useSelectedConfigurations;
